import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ManufacturersResponseDto } from '../dtos/manufacturer.dto';

@Injectable({
    providedIn: 'root'
})
export class ManufacturersService {
    private readonly MANUFACTURERS_GET = 'configuration/manufacturers';
    public constructor(private http: HttpClient) {}

    public getAllManufacturers(): Observable<ManufacturersResponseDto> {
        return this.http.get<ManufacturersResponseDto>(environment.outgoingRequestAPI + this.MANUFACTURERS_GET);
    }
}
